export const UNKNOWN_ERROR = 'UNKNOWN_ERROR';
export const IMPLEMENTATION_ERROR = 'IMPLEMENTATION_ERROR';
export const ENGINE_ERROR = 'ENGINE_ERROR';
export const BRIDGE_ERROR = 'BRIDGE_ERROR';
